
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 109 81","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M21.62 61.08c.953-2.34 1.462-3.89 2.19-5.33a5508.663 5508.663 0 0115.566-30.52c2.066-4.018 3.129-4.11 6.057-.67a6820.213 6820.213 0 0115.78 18.594c3.095 3.661 4.716 3.747 7.975.317.828-.87 1.544-1.856 2.412-2.684 1.997-1.907 3.993-2.214 5.538.485A857.16 857.16 0 0186.152 57.4c1.313 2.413.477 3.687-2.31 3.686-20.467-.01-40.933-.005-62.222-.005zm56.477-40.406c3.452-.132 6.558 2.847 6.715 6.44.162 3.682-2.512 6.723-6.098 6.933-3.892.228-6.916-2.596-6.973-6.513-.052-3.504 2.938-6.73 6.356-6.86z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M100.354 0H8.651A7.696 7.696 0 00.955 7.696v65.608A7.696 7.696 0 008.651 81h91.703a7.696 7.696 0 007.696-7.697V7.697A7.696 7.696 0 00100.354 0zm-6.332 66.746h-79.04V14.254h79.04v52.492z","clip-rule":"evenodd"}})])
          )
        }
      }
    